export default __webpack_public_path__ + "static/JofMicr-frontcover-c3772793e981186f659cd6be61d4fbcd.jpg";